import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { withContentTheme } from '../../../theme';
import { jsx as ___EmotionJSX } from "@emotion/core";

var GroupHeadingPrimitive = function GroupHeadingPrimitive(_ref) {
  var After = _ref.after,
      children = _ref.children,
      theme = _ref.theme;
  var mode = theme.mode,
      context = theme.context;
  var styles = mode.heading()[context];
  return ___EmotionJSX("div", {
    css: styles.headingBase
  }, ___EmotionJSX("div", {
    css: styles.textWrapper
  }, children), !!After && ___EmotionJSX("div", {
    css: styles.afterWrapper
  }, ___EmotionJSX(After, null)));
};

var GroupHeadingPrimitiveWithTheme = withContentTheme(GroupHeadingPrimitive); // TODO: This component is only defined to pass correct props to our prop docs
// as we require classes for them. Remove once we fix this on the prop doc level.

var GroupHeading = /*#__PURE__*/function (_Component) {
  _inherits(GroupHeading, _Component);

  var _super = _createSuper(GroupHeading);

  function GroupHeading() {
    _classCallCheck(this, GroupHeading);

    return _super.apply(this, arguments);
  }

  _createClass(GroupHeading, [{
    key: "render",
    value: function render() {
      return ___EmotionJSX(GroupHeadingPrimitiveWithTheme, this.props);
    }
  }]);

  return GroupHeading;
}(Component);

export { GroupHeading as default };